import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { AppRouter } from "../../../../lambdas/api/src/router";
import { TRPC_API_URL } from "./constants";

export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: TRPC_API_URL,
    }),
  ],
});
